import { inject, provideAppInitializer } from "@angular/core";
import {
  ASSET_BUILDER_BASE_API_CONFIG,
  BrowserFilePickerService,
  FILE_PICKER_SERVICE,
  provideAssetModulesTranslations,
  TranslateService as AssetModuleTranslateService
} from "@rvi/asset-modules";
import { environment } from "../environments/environment";
import { NetworkStatusService } from "./_services/network-status.service";
import { LangUpdateService } from "./_services/lang-update.service";
import { ElectronFilePickerService } from "./common-dialog/file-manager/electron-file-picker.service";
import { FileManagerService } from "./common-dialog/file-manager/file-manager.service";
import { MatDialog } from "@angular/material/dialog";
import { mode } from "../mode/mode";

export function provideAssetModuleConfiguration() {
  return [
    provideAssetModuleApiConfig(),
    provideAssetModulesTranslations(),
    provideFileManager(),
    provideAppInitializer(() => {
      const langUpdate = inject(LangUpdateService);
      const assetTranslate = inject(AssetModuleTranslateService);
      langUpdate.currentLanguageChanged.subscribe((lang) => {
        assetTranslate.changeLanguage(lang);
      });
    })
  ];
}

function provideAssetModuleApiConfig() {
  return {
    provide: ASSET_BUILDER_BASE_API_CONFIG,
    useFactory: (networkStatusService: NetworkStatusService) => ({
      get apiUrl() {
        if (networkStatusService.isOffline) {
          return environment.ASSET_MODULE_OFFLINE;
        }
        return environment.PROTECTED_URIS.ASSET_MODULE;
      }
    }),
    deps: [NetworkStatusService]
  };
}

function provideFileManager() {
  const isBrian = () => mode.name == "brian";
  return {
    provide: FILE_PICKER_SERVICE,
    useFactory: (dialog: MatDialog, fileManagerService: FileManagerService) => {
      return isBrian() ? new ElectronFilePickerService(dialog, fileManagerService) : new BrowserFilePickerService();
    },
    deps: [MatDialog, FileManagerService]
  };
}
